import { FunctionComponent, JSX } from 'react'
import { Daycare, DaycarePredefinedMessageType, DaycareType } from '@/types/Daycare'
import styles from '../customisation.module.scss'
import PredefinedMessage from './predefinedMessage.tsx'
import Title from '@/components/_custom/Title/title.tsx'
import { useTranslation } from 'react-i18next'

interface PredefinedMessageListProps {
    daycare: Daycare
}

const PredefinedMessageList: FunctionComponent<PredefinedMessageListProps> = ({
    daycare
}: PredefinedMessageListProps) => {
    const { t } = useTranslation()

    function renderUniqueMessage(messageType: string): JSX.Element {
        return <PredefinedMessage key={messageType} messageType={messageType as DaycarePredefinedMessageType} />
    }

    const isRPEOrLAEP: boolean = daycare.type === DaycareType.rpe || daycare.type === DaycareType.laep

    return daycare.predefinedMessages ? (
        <>
            <div className={styles.Container}>
                <div className={styles.Form}>
                    <div className={styles.TitleAndButton}>
                        <Title
                            text={
                                t('myPredefinedMessages') +
                                ' - ' +
                                t(isRPEOrLAEP ? 'animationSlots' : 'occasionalSlots')
                            }
                            className={styles.Title}
                        />
                    </div>
                    {Object.keys(DaycarePredefinedMessageType)
                        .filter((value: string): boolean => {
                            return value === DaycarePredefinedMessageType.cancelOccasionalSlot
                        })
                        .map((messageType: string): JSX.Element => renderUniqueMessage(messageType))}
                </div>
            </div>
            <div className={styles.Container}>
                <div className={styles.Form}>
                    <div className={styles.TitleAndButton}>
                        <Title
                            text={
                                t('myPredefinedMessages') + ' - ' + t(isRPEOrLAEP ? 'regularsGroups' : 'regularSlots')
                            }
                            className={styles.Title}
                        />
                    </div>
                    {Object.keys(DaycarePredefinedMessageType)
                        .filter((value: string): boolean => {
                            return (
                                value === DaycarePredefinedMessageType.acceptRegularRequest ||
                                value === DaycarePredefinedMessageType.rejectRegularRequest ||
                                value === DaycarePredefinedMessageType.declareAbsenceRegularSlot
                            )
                        })
                        .map((messageType: string): JSX.Element => renderUniqueMessage(messageType))}
                </div>
            </div>
            <div className={styles.Container}>
                <div className={styles.Form}>
                    <div className={styles.TitleAndButton}>
                        <Title text={t('myPredefinedMessages') + ' - ' + t('requestSlot')} className={styles.Title} />
                    </div>
                    {Object.keys(DaycarePredefinedMessageType)
                        .filter((value: string): boolean => {
                            return (
                                value === DaycarePredefinedMessageType.acceptRequestSlot ||
                                value === DaycarePredefinedMessageType.rejectRequestSlot
                            )
                        })
                        .map((messageType: string): JSX.Element => renderUniqueMessage(messageType))}
                </div>
            </div>
        </>
    ) : null
}

export default PredefinedMessageList
